export default __webpack_public_path__ + "static/media/661.e2394e70.png";